export const caoWijzerNavigationCodes = {
	dashboard: 16704,
	caoNewsList: 16705,
	cao: 16706,
	caoInstanceList: 16707,
	caoWagesList: 16708,
	caoWagesRequestsList: 16709,
	wmlList: 16710,

	user: 16711,
	savedFilter: 16712,
	savedFilterMyFiltersList: 16713,
	savedFilterSystemFiltersList: 16714,
	savedFilterOtherUsersFiltersList: 16715,
	savedFilterAlertLogsList: 16716,
} as const;
